class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.events = {
      backInStock: 'back-in-stock:change',
    };
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    document.dispatchEvent(new CustomEvent(this.events.backInStock, { detail: this.currentVariant }));

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData()
      .find((variant) => !variant.options.map((option, index) => this.options[index] === option)
        .includes(false));
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => parent.scroll(0, 0));
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        const skuElementId = 'product-variant-sku';
        const skuDestination = document.getElementById(skuElementId);
        const skuSource = html.getElementById(skuElementId);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (skuSource && skuDestination) skuDestination.innerHTML = skuSource.innerHTML;

        document.getElementById(`price-${this.dataset.section}`).classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        try {
          if (this.currentVariant.available === false) {
            document.getElementById('soldoutNotify').classList.remove('visually-hidden');
          } else {
            document.getElementById('soldoutNotify').classList.add('visually-hidden');
          }
        } catch (error) {}
        this.clonedAddToCart();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return; // eslint-disable-line
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`).classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(document.querySelector('#VariantJSON').textContent);
    return this.variantData;
  }

  clonedAddToCart() {
    const addToCartId = document.querySelector('#ButtonAddToCart');
    const stickyAddToCartItems = document.querySelectorAll('.button-addtocart-sticky > div');
    const clonedthis = addToCartId.cloneNode(true);
    document.querySelector('.button-addtocart-sticky').appendChild(clonedthis);
    stickyAddToCartItems.forEach((elem, i) => {
      if (i !== 1) { elem.remove(); }
    });
  }

  connectedCallback() {
    this.openSizeSelector();
    this.dispatchEvent(new Event('change'));
  }

  openSizeSelector() {
    this.sizeSelector = this.querySelector('[data-size-selector]');
    this.selector = this.querySelector('.product-form__inputradio');

    const sizeSelectorObserver = new MutationObserver((entries) => {
      this.sizeSelector.setAttribute('open', '');
      sizeSelectorObserver.disconnect();
    });

    if (this.selector) {
      sizeSelectorObserver.observe(this.sizeSelector, {
        subtree: true,
        characterData: true,
        childList: true,
        attributes: true,
      });
    }

    if (!this.selector) {
      this.sizeSelector.setAttribute('open', '');
    }
  }
}

customElements.get('variant-selects') || customElements.define('variant-selects', VariantSelects); // eslint-disable-line

class VariantRadios extends VariantSelects {
  constructor() { // eslint-disable-line
    super(); // eslint-disable-line
  } // eslint-disable-line

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value);
  }
}

customElements.get('variant-radios') || customElements.define('variant-radios', VariantRadios); // eslint-disable-line
